/**
 * Audiences a study can be fielded on. Home Lab and the study builder must
 * agree: `ready` and `relaunching` are selectable, anything else is not.
 */
export function isSelectableStudyAudienceStatus(
  status: string | null | undefined,
): boolean {
  return status === 'ready' || status === 'relaunching'
}

/** A relaunching audience stays selectable, but only after the refresh dialog. */
export function isRelaunchingStudyAudienceStatus(
  status: string | null | undefined,
): boolean {
  return status === 'relaunching'
}

export function selectDeepLinkedAudience<
  T extends { id: string; status?: string | null },
>(populations: Array<T>, audienceId: string | null | undefined): T | null {
  if (!audienceId) {
    return null
  }
  return (
    populations.find(
      (population) =>
        population.id === audienceId &&
        isSelectableStudyAudienceStatus(population.status),
    ) ?? null
  )
}
